<div
  [ngClass]="{
    input: !(formControl.invalid && formControl.touched),
    'input-error': formControl.invalid && formControl.touched
  }"
>
  <!-- <label class="input-label-item" for="{{for}}">{{ label }}</label> -->
  <div class="input-wrapper">
    <input
      #inputSearch
      [formControl]="formControl"
      class="input-head-item"
      placeholder="{{ label }}"
    />
    <i class="icon-medium icon-rigth icon-search-2x"></i>
  </div>
  @if (formControl.invalid && formControl.touched) {
    <div>
      @if (formControl.errors?.['required']) {
        <div class="input-error">Este campo es requerido</div>
      }
      @if (formControl.errors?.['minlength']) {
        <div class="input-error">No cumple la longitud minima</div>
      }
      @if (formControl.errors?.['maxlength']) {
        <div class="input-error">No cumple la longitud maxima</div>
      }
      @if (formControl.errors?.['email']) {
        <div class="input-error">Correo Invalido</div>
      }
    </div>
  }
  @if (helpLabel || !formControl.errors?.['email']) {
    <div class="input-help-label">
      {{ helpLabel }}
    </div>
  }
</div>
